import PaysController from './pays.controller';

export default {
    template: require('./pays.tpl.html'),
    controller: PaysController
};
